import { buildSearchText } from "../../utils/adminUtils";

export const formatStoreAddress = (source = {}) =>
  [
    source.physicalAddress,
    source.physicalNumber,
    source.physicalDistrict,
    source.physicalCity,
    source.physicalState,
    source.physicalPostalCode,
    source.physicalCountry,
  ]
    .filter(Boolean)
    .join(", ");

// Pendentes vêm como { verification, convention }; aprovadas vêm com os campos direto na raiz.
// As duas viram o mesmo formato de linha.
const toRow = (source, { convention = null, status, key }) => {
  const owner = source.store?.username || "";
  const name = source.physicalStoreName || "";
  const address = formatStoreAddress(source);
  return {
    id: key,
    name,
    address,
    city: source.physicalCity || "",
    owner,
    photoId: source.proofPhotoId,
    photoUrl: source.proofPhotoUrl,
    submittedAt: source.submittedAt,
    submittedValue: source.submittedAt ? new Date(source.submittedAt).getTime() || 0 : 0,
    status: source.verificationStatus || status,
    convention,
    searchText: buildSearchText([name, owner, address, convention?.companyName, convention?.taxId]),
  };
};

export const toPendingRow = (item, index) =>
  toRow(item.verification || {}, {
    convention: item.convention || null,
    status: "PENDING",
    key: item.id ?? item.verification?.id ?? `pending-${index}`,
  });

export const toApprovedRow = (item, index) =>
  toRow(item, { status: "APPROVED", key: item.id ?? `approved-${index}` });
